import React from 'react';
import { BookOpen, X } from 'lucide-react';
import { Dialog, DialogContent, DialogTitle, DialogDescription } from '../ui/dialog';

const rules = [
  'Do not spam or use excessive capital letters.',
  'Do not harass, abuse, or insult other players or GVRewards staff.',
  'Do not share personal information, passwords, or account details belonging to yourself or others.',
  'Do not beg or request loans, tips, or free V credits.',
  'Do not use alternate accounts to bypass chat restrictions.',
  'Do not engage in suspicious behaviour, scams, or impersonation.',
  'Do not advertise, trade, sell, buy, or offer services.',
  'Do not promote unrelated streamers, channels, or platforms.',
  'Do not use URL shorteners; always share full links.',
  'Do not share scripts, bots, exploits, or automation tools.',
  'Use English in the community chat.',
  'Keep politics and religion out of chat.',
];

export const ChatRules = ({ open, onOpenChange }) => <Dialog open={open} onOpenChange={onOpenChange}>
  <DialogContent className="chat-rules-dialog [&>button]:hidden" data-testid="chat-rules-dialog">
    <div className="chat-dialog-heading"><DialogTitle data-testid="chat-rules-title"><BookOpen size={19} />Chat Rules</DialogTitle><button type="button" data-testid="chat-rules-close" aria-label="Close chat rules" onClick={() => onOpenChange(false)}><X size={20} /></button></div>
    <DialogDescription className="sr-only" data-testid="chat-rules-description">GVRewards community chat rules</DialogDescription>
    <ol className="chat-rules-list" data-testid="chat-rules-list">{rules.map((rule, index) => <li key={rule} data-testid={`chat-rule-${index + 1}`}>{rule}</li>)}</ol>
  </DialogContent>
</Dialog>;